import React, { useState } from 'react';
import './carousel.css';
import { useResources } from '../../store/resourcesProvider';

type Props = {
    images: string[];
};

const Carousel: React.FC<Props> = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const resources = useResources();

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    // fallback image path in client public folder
    const fallback = '/voice1.jpg';

    return (
        <div className="carousel">
            <button className="prev" onClick={prevSlide} aria-label={resources.get('About.Prev','הקודם')}>{resources.get('About.Prev','הקודם')} <span className="sr-only">(Previous)</span></button>
            <div className="carousel-image" role="img" aria-label={`Slide ${currentIndex + 1}`}>
                <img
                    src={images[currentIndex]}
                    alt={`Slide ${currentIndex + 1}`}
                    onError={(e) => {
                        const img = e.currentTarget as HTMLImageElement;
                        try { img.onerror = null; } catch { }
                        img.src = fallback;
                    }}
                />
            </div>
            <button className="next" onClick={nextSlide} aria-label={resources.get('About.Next','הבא')}>{resources.get('About.Next','הבא')} <span className="sr-only">(Next)</span></button>
        </div>
    );
};

export default Carousel;